export default {
    en: "English",
    cs: "Česky",
    de: "Deutsch",
    es: "Español",
    it: "Italiano",
    sv: "Svenska"
}